import { Stack, Typography, useTheme } from '@mui/material';
import { PieChart, Pie, Legend, Tooltip } from 'recharts';

const data = [
  { name: 'Web and mobile development', value: 2, fill: '#002D69' },
  { name: 'MERN stack development', value: 3, fill: '#212121' },
  { name: 'Data Analysis', value: 5, fill: '#3357FF' },
  { name: 'Communication', value: 2, fill: '#383838' },
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = props => {
  // console.log(props);
  const { value, cx, cy, midAngle, innerRadius, outerRadius, percent, index } =
    props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${value} years`}
    </text>
  );
};

export default function DomainPieChart({ chartData }) {
  return (
    <Stack sx={{ marginTop: '-10px' }}>
      <PieChart width={720} height={400}>
        <Pie
          dataKey="value"
          data={chartData}
          cx={200}
          cy={200}
          outerRadius={130}
          fill="#8884d8"
          labelLine={false}
          label={renderCustomizedLabel}
          stroke="none"
        />
        <Legend
          align="right"
          verticalAlign="middle"
          layout="vertical"
          formatter={(value, entry) => (
            <Typography
              varaint="input"
              sx={{
                color: entry.color,
                fontSize: '1.1rem',
                marginLeft: '10px',
                display: 'inline-block',
                width:"38vh"
              }}
            >
              {value}
            </Typography>
          )}
          // margin={{ top: 10, right: 30, bottom: 10, left: 0 }}
        />
        <Tooltip />
      </PieChart>
      <style>
        {`
          .recharts-legend-item {
            margin-bottom: 15px; /* Adjust the margin as needed */
          }
        `}
      </style>
    </Stack>
  );
}
